export default __webpack_public_path__ + "static/media/pokedex.a9ad5605.png";